(() => {
  'use strict';
  document.querySelectorAll('[data-redeem-voucher]').forEach(link => {
    if (link.dataset.bound) return;
    link.dataset.bound = 'true';
    link.addEventListener('click', event => {
      try {
        const code = link.dataset.redeemVoucher;
        if (!/^HFV-[A-F0-9]{32}$/.test(code)) throw new Error();
        sessionStorage.setItem('holafish.sockVoucher', code);
      } catch (_) {
        event.preventDefault();
        const error = document.querySelector('[data-voucher-wallet-error]');
        error.hidden = false;
        error.textContent = 'Please enable browser storage to choose your design, or contact us for help redeeming your voucher.';
      }
    });
  });
  document.querySelectorAll('[data-membership-form]').forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    const radios = form.querySelectorAll('[data-membership-plan]');
    const hidden = form.querySelector('[data-membership-selling-plan]');
    const consent = form.querySelector('[data-membership-consent]');
    const button = form.querySelector('[data-membership-add]');
    const terms = form.querySelector('[data-membership-terms]');
    const expected = {1: 1500, 3: 3600, 12: 12000};
    const refresh = () => {
      const checked = form.querySelector('[data-membership-plan]:checked');
      const months = Number(checked?.dataset.months);
      const price = Number(checked?.dataset.price);
      const valid = Boolean(checked?.dataset.plan) && expected[months] === price;
      hidden.value = valid ? checked.dataset.plan : '';
      button.disabled = !valid;
      consent.checked = false;
      terms.textContent = valid
        ? `$${(price / 100).toFixed(2)} charged today and every ${months === 1 ? 'month' : months + ' months'} until canceled. One voucher is issued each month.`
        : 'Choose an available plan. If plans are unavailable, please contact us.';
    };
    radios.forEach(radio => radio.addEventListener('change', refresh));
    refresh();
    form.addEventListener('submit', event => {
      if (!hidden.value || !form.checkValidity()) {
        event.preventDefault(); form.reportValidity();
      }
    });
  });
})();
